<div
	class="input"
	matTooltip="{{ errorText }}"
	matTooltipClass="pv-tooltip"
	matTooltipPosition="below"
	[class.disabled]="disabled"
	[matTooltipDisabled]="!error || !errorText"
	(keyup)="handleKeyUp($event)"
>
	<label>
		@if (value || value === 0) {
			@if (labelTemplate) {
				<ng-template [ngTemplateOutlet]="labelTemplate" [ngTemplateOutletContext]="{ $implicit: value }" />
			} @else {
				{{ value }}
			}
		} @else {
			{{ placeholder }}
		}
	</label>
	@if (!disabled) {
		<ic-fa-icon icon="caret-down" />
	}
</div>

@if (showList && !disabled) {
	<div class="options">
		<ul #list>
			@if (items && items.length > 0) {
				@for (item of items; track item; let i = $index) {
					<li
						#listItem
						tabindex="0"
						[attr.data-test]="'option-' + (item?.['id'] ?? item)"
						(blur)="blur(i)"
						(click)="selectItem(item)"
						(focus)="setItemIndex(i)"
						(keydown.space)="selectItem(item)"
						(keyup)="handleKeyUp($event, item)"
					>
						@if (itemTemplate) {
							<ng-template [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: item }" />
						} @else {
							{{ item }}
						}
					</li>
				}
			} @else {
				<li><ng-template [ngTemplateOutlet]="emptyTemplate" /></li>
			}
		</ul>
	</div>
}
